import React from "react";
import "../Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright © 2025 Flipped Learning LMS</p>
    </footer>
  );
};

export default Footer;
